// extracted by mini-css-extract-plugin
export default {"TermsAndConditions":"TermsAndConditions_TermsAndConditions__l924I","text":"TermsAndConditions_text__AUsGA"};